import request from "@/utils/request";

function accessLog() {
  this.baseUrl = "";
  this.visitId = "0";
  this.time = new Date().getTime();
}

accessLog.prototype.setBaseUrl = function(url) {
  this.baseUrl = url;
};

accessLog.prototype.saveAccessLog = function(uid) {
  let data = new FormData();
  data.append("l", escape(document.referrer));
  data.append("u", escape(window.location));
  data.append("navUA", escape(navigator.userAgent));
  data.append("uid", uid);
  data.append("title", escape(document.title));

  let _this = this;
  request({
    url: this.baseUrl + "SaveVisitlog",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
    .then(data => {
      _this.visitId = data;
    })
    .catch(err => {
      console.log(err);
    });
};

accessLog.prototype.closeVisit = function() {
  let second = ((new Date().getTime() - this.time) / 1000) | 0;
  let data = new FormData();
  data.append("visitid", this.visitId || "0");
  data.append("tjSecond", second.toString());
  request({
    url: this.baseUrl + "CloseVisit",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};

export default accessLog;
